export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
export const CONSUMER_URL = import.meta.env.VITE_CONSUMER_URL;
export const EXTRACTION_URL = import.meta.env.VITE_EXTRACTION_URL;

export const NIMBLE_AUTH_API = import.meta.env.VITE_NIMBLE_AUTH_API;
export const NIMBLE_PAYABLE_API = import.meta.env.VITE_NIMBLE_PAYABLE_API;